import React, { PureComponent } from 'react'
import { GroupLink } from '../GroupLink'
import {
  TabContentWrapper,
  GroupWrapper,
} from './TabContent.elements'

type Props = {
  content: NavGroupType
  onItemSelect?: () => void
}

export class TabContent extends PureComponent<Props> {
  render() {
    const { content, onItemSelect } = this.props
    const groupSize = content.layout === 'symmetric'
      ? 100 / content.sections.length
      : undefined

    return (
      <TabContentWrapper>
        {content.sections.map((section, idx) => (
          <GroupWrapper
            key={idx}
            size={groupSize}
          >
            <GroupLink
              links={section.links}
              title={section.title}
              onItemSelect={onItemSelect}
            />
          </GroupWrapper>
        ))}
      </TabContentWrapper>
    )
  }
}
